// Generated by `python -m sx_service console-ts` from sx_service.registry.
// Do not edit — `just check` regenerates this file and fails on any diff.

export const CONSOLE_DEV_PORT = 8080;

/** The one coordinate for the project: the address, in the router's own parameter
 * syntax. Both segments are slugs. Every project-scoped workspace hangs from it. */
export const PROJECT_SCOPE_PREFIX = "/p/$org/$project";

/** Every door the console speaks to, reached at `/d/<id>` on the console origin. */
export const CONSOLE_DOORS = [
  {
    id: "source",
    prefix: "/d/source",
    apiDevUrl: "http://127.0.0.1:8401/d/source",
    audiences: ["auth"],
  },
  {
    id: "factory",
    prefix: "/d/factory",
    apiDevUrl: "http://127.0.0.1:8401/d/factory",
    audiences: ["factory", "factory-operations"],
  },
  {
    id: "labeler",
    prefix: "/d/labeler",
    apiDevUrl: "http://127.0.0.1:8401/d/labeler",
    audiences: ["labeler"],
  },
  {
    id: "catalog",
    prefix: "/d/catalog",
    apiDevUrl: "http://127.0.0.1:8401/d/catalog",
    audiences: ["catalog"],
  },
  {
    id: "waddle",
    prefix: "/d/waddle",
    apiDevUrl: "http://127.0.0.1:8401/d/waddle",
    audiences: ["waddle"],
  },
  {
    id: "worlds",
    prefix: "/d/worlds",
    apiDevUrl: "http://127.0.0.1:8401/d/worlds",
    audiences: ["worlds"],
  },
  {
    id: "autonomy",
    prefix: "/d/autonomy",
    apiDevUrl: "http://127.0.0.1:8401/d/autonomy",
    audiences: ["auto-improve", "train"],
  },
  {
    id: "fleet",
    prefix: "/d/fleet",
    apiDevUrl: "http://127.0.0.1:8401/d/fleet",
    audiences: ["fleet"],
  },
  {
    id: "auth",
    prefix: "/d/auth",
    apiDevUrl: "http://127.0.0.1:8401/d/auth",
    audiences: ["auth"],
  },
] as const;

export type ConsoleDoorId = (typeof CONSOLE_DOORS)[number]["id"];

export const CONSOLE_WORKSPACE_GROUPS = ["Projects", "Library", "Simulation", "Training", "Data operations", "Robot operations"] as const;

/** The human workspaces, each mounted under its route prefix. */
export const CONSOLE_WORKSPACES = [
  {
    id: "projects",
    group: "Projects",
    name: "Projects",
    routeBase: "/p/$org/$project",
    audiences: ["auth", "auto-improve", "catalog", "compute", "factory", "factory-operations", "fleet", "labeler", "supervisors", "telemetry", "train", "waddle", "worlds"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "experience-library",
    group: "Library",
    name: "Library",
    routeBase: "/p/$org/$project/library",
    audiences: ["catalog"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "work-atlas",
    group: "Projects",
    name: "Work Atlas",
    routeBase: "/p/$org/$project/work-atlas",
    audiences: ["catalog"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: "tasks",
  },
  {
    id: "worlds",
    group: "Simulation",
    name: "Simulation",
    routeBase: "/p/$org/$project/simulate",
    audiences: ["worlds"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "world-authoring",
    group: "Simulation",
    name: "World drafts",
    routeBase: "/p/$org/$project/build-worlds",
    audiences: ["worlds"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: "worlds",
    projectPage: null,
  },
  {
    id: "autonomy-training",
    group: "Training",
    name: "Training",
    routeBase: "/p/$org/$project/training",
    audiences: ["train", "waddle"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "experience-production",
    group: "Data operations",
    name: "Production",
    routeBase: "/production",
    audiences: ["factory"],
    projectScoped: false,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "experience-label",
    group: "Data operations",
    name: "Labeling",
    routeBase: "/label",
    audiences: ["labeler"],
    projectScoped: false,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "experience-orders",
    group: "Data operations",
    name: "Orders",
    routeBase: "/p/$org/$project/orders",
    audiences: ["catalog"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "supply",
    group: "Data operations",
    name: "Supply",
    routeBase: "/p/$org/$project/supply",
    audiences: ["catalog"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: "experience-orders",
    projectPage: null,
  },
  {
    id: "robot-fleet",
    group: "Robot operations",
    name: "Units",
    routeBase: "/operations",
    audiences: ["factory"],
    projectScoped: false,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "fleet-deployment",
    group: "Robot operations",
    name: "Deployments",
    routeBase: "/p/$org/$project/deploy",
    audiences: ["fleet"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "fleet-teleoperators",
    group: "Robot operations",
    name: "Teleoperators",
    routeBase: "/teleoperators",
    audiences: ["supervisors"],
    projectScoped: false,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
  {
    id: "autonomy-improve",
    group: "Projects",
    name: "Agents",
    routeBase: "/p/$org/$project/loop",
    audiences: ["auto-improve"],
    projectScoped: true,
    requiresOrganizationMembership: false,
    tabOf: null,
    projectPage: null,
  },
] as const;

export type ConsoleWorkspace = (typeof CONSOLE_WORKSPACES)[number];
export type WorkspaceId = (typeof CONSOLE_WORKSPACES)[number]["id"];

/** Project destinations; the URL owns their selection in every product area. */
export const PROJECT_PAGES = [
  { id: "operation", name: "Conversation", to: "/p/$org/$project", adminOnly: false },
  { id: "team", name: "Team", to: "/p/$org/$project/loop/team", adminOnly: false },
  { id: "board", name: "Board", to: "/p/$org/$project/loop/board", adminOnly: false },
  { id: "tasks", name: "Tasks", to: "/p/$org/$project/tasks", adminOnly: false },
  { id: "operations", name: "Operations", to: "/p/$org/$project/operations", adminOnly: false },
  { id: "robots", name: "Robots", to: "/p/$org/$project/robots", adminOnly: false },
  { id: "reports", name: "Reports", to: "/p/$org/$project/reports", adminOnly: false },
  { id: "settings", name: "Settings", to: "/p/$org/$project/settings", adminOnly: true },
] as const;

export const DEFAULT_WORKSPACE_ID: WorkspaceId = "projects";

/** The four platform pillars, from `sx_service.registry.Pillar`, spelled as copy
 * would spell them. They name the agent surfaces and are ownership, not navigation
 * (`docs/BRAND.md` §11): no human address and no visible copy says one. */
export const PLATFORM_PILLARS = ["Experience", "Worlds", "Autonomy", "Fleet"] as const;

/** The two PostHog group types, from `sx_service.analytics.GroupType`.
 *
 * The platform's two nouns. The console associates a session with both and the
 * doors send both on every event, so a funnel that starts at a page view and ends
 * at a door request is one funnel over one group rather than two populations. */
export const GROUP_ORGANIZATION = "organization";
export const GROUP_PROJECT = "project";

/** Every address a person may open, from `docs/quality-ledger.yaml`.
 *
 * The one ledger row that answers for an address decides: `works` or `degraded`
 * and it is here, anything else and it is not. An address that is not here is a
 * typed 404 (`shell/NotFound.tsx`) and a line on the ledger page's backlog —
 * never a styled empty page. Navigation offers only what this set admits.
 *
 * Written by `python tools/ledger.py --console-ts`. Nothing may be added by hand:
 * the way to open an address is to make its ledger row true.
 */
export const NAVIGABLE_ROUTES: ReadonlySet<string> = new Set([
  "/",
  "/$",
  "/headset",
  "/label",
  "/label/admin",
  "/label/annotate/$episodeId",
  "/label/audit",
  "/label/audit/$episodeId",
  "/label/principal",
  "/label/qc",
  "/label/qc/accuracy",
  "/operations",
  "/operations/releases",
  "/p/$org/$project",
  "/p/$org/$project/build-worlds",
  "/p/$org/$project/build-worlds/assets",
  "/p/$org/$project/build-worlds/assets/$worldId",
  "/p/$org/$project/build-worlds/create",
  "/p/$org/$project/build-worlds/drafts/$draftId",
  "/p/$org/$project/deploy",
  "/p/$org/$project/deploy/$robot",
  "/p/$org/$project/deploy/$robot/sessions/$session",
  "/p/$org/$project/deploy/ladders/$",
  "/p/$org/$project/deploy/stations",
  "/p/$org/$project/deploy/stations/$stationId",
  "/p/$org/$project/library",
  "/p/$org/$project/library/agents/$agentId",
  "/p/$org/$project/library/contracts/$id",
  "/p/$org/$project/library/datasets/$name",
  "/p/$org/$project/library/datasets/$name/segments/$segmentId",
  "/p/$org/$project/library/episodes/$sessionId/$episodeId",
  "/p/$org/$project/library/issues",
  "/p/$org/$project/library/items/$name",
  "/p/$org/$project/library/map",
  "/p/$org/$project/library/search",
  "/p/$org/$project/library/semantic",
  "/p/$org/$project/loop",
  "/p/$org/$project/loop/agent/$agentId/{-$sessionId}",
  "/p/$org/$project/loop/board",
  "/p/$org/$project/loop/manager",
  "/p/$org/$project/loop/team",
  "/p/$org/$project/operations",
  "/p/$org/$project/orders",
  "/p/$org/$project/reports",
  "/p/$org/$project/reports/$name",
  "/p/$org/$project/reports/$name/changes",
  "/p/$org/$project/reports/$name/edit",
  "/p/$org/$project/reports/$name/versions/$version",
  "/p/$org/$project/reports/model",
  "/p/$org/$project/reports/new",
  "/p/$org/$project/robots",
  "/p/$org/$project/robots/bodies/$body",
  "/p/$org/$project/robots/compose",
  "/p/$org/$project/settings",
  "/p/$org/$project/simulate",
  "/p/$org/$project/simulate/assets/$worldId",
  "/p/$org/$project/simulate/create",
  "/p/$org/$project/simulate/drafts",
  "/p/$org/$project/simulate/drafts/$draftId",
  "/p/$org/$project/simulate/runs",
  "/p/$org/$project/simulate/sessions",
  "/p/$org/$project/supply",
  "/p/$org/$project/supply/orders",
  "/p/$org/$project/supply/shipments",
  "/p/$org/$project/tasks",
  "/p/$org/$project/tasks/$taskId",
  "/p/$org/$project/training",
  "/p/$org/$project/training/compare",
  "/p/$org/$project/training/jobs/$jobId",
  "/p/$org/$project/training/research",
  "/p/$org/$project/training/research/$sessionName",
  "/p/$org/$project/training/runs",
  "/p/$org/$project/training/runs/$runId",
  "/p/$org/$project/work-atlas",
  "/p/$org/$project/work-atlas/home",
  "/p/$org/$project/work-atlas/occupations",
  "/p/$org/$project/work-atlas/opportunities",
  "/p/$org/$project/work-atlas/skills",
  "/p/$org/$project/work-atlas/tasks",
  "/production",
  "/production/activity",
  "/production/checks",
  "/production/collections",
  "/production/collections/$collectionId",
  "/production/episodes",
  "/production/episodes/$episodeId",
  "/production/operators",
  "/production/people",
  "/production/pods",
  "/production/pods/$podId",
  "/production/pods/$podId/$episodeId",
  "/production/uploads",
  "/projects",
  "/settings",
  "/settings/billing",
  "/settings/keys",
  "/settings/operators",
  "/settings/organizations",
  "/settings/organizations/$organizationId",
  "/settings/organizations/$organizationId/billing",
  "/settings/people",
  "/settings/platform",
  "/settings/platform/act-as",
  "/settings/platform/audiences",
  "/settings/platform/nodes",
  "/settings/platform/organizations",
  "/settings/platform/principals",
  "/settings/projects",
  "/settings/projects/$projectId",
  "/settings/sessions",
  "/signed-out",
  "/supervise/$",
  "/teleoperators",
  "/teleoperators/cockpit/$ticketId",
  "/teleoperators/people",
  "/teleoperators/sessions",
]);
